import React from "react";
import { Check } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const ThankYouPreview = ({ page, form, defaults }) => {
  if (page.kind === "buyer" && form.inherit) {
    return (
      <div data-testid="admin-ty-preview">
        <div className="label-mono mb-2">Live preview</div>
        <div className="border-2 border-dashed border-black p-5 text-center text-[11px] text-zinc-600" data-testid="admin-ty-preview-inherit">
          This buyer&apos;s thank-you page follows the funnel the lead came through. Open that funnel&apos;s Thank-you page settings to see it.
        </div>
      </div>
    );
  }
  const d = form.display;
  const firm = page.firm_name || "Matched law firm";
  const logo = page.logo_url ? `${BACKEND}${page.logo_url}` : null;
  const steps = form.custom_timeline ? form.timeline.filter((s) => s.title.trim()) : defaults.timeline;
  return (
    <div data-testid="admin-ty-preview">
      <div className="label-mono mb-2">Live preview</div>
      <div className="border-2 border-black bg-[#0a1929] p-5 text-center text-slate-200">
        <div className="mx-auto grid h-10 w-10 place-items-center rounded-full bg-emerald-500 text-white"><Check size={20} weight="bold" /></div>
        {d.show_logo && (logo
          ? <img src={logo} alt="" className="mx-auto mt-3 h-10 max-w-[140px] rounded bg-white object-contain p-1" data-testid="admin-ty-preview-logo" />
          : <div className="mx-auto mt-3 grid h-9 w-24 place-items-center border border-dashed border-white/30 text-[9px] uppercase tracking-widest text-slate-400" data-testid="admin-ty-preview-logo">Logo</div>)}
        {d.show_firm_name && <div className="mt-2 text-[11px] font-bold uppercase tracking-widest" data-testid="admin-ty-preview-firm">{firm}</div>}
        <div className="mt-3 text-lg font-bold leading-snug text-white" data-testid="admin-ty-preview-headline">
          {form.headline || (d.show_firm_name ? `You're matched with ${firm}` : "Your case request is in")}
        </div>
        {d.show_call_text && (
          <div className="mt-3 flex justify-center gap-2" data-testid="admin-ty-preview-buttons">
            <span className="rounded-full bg-white px-3 py-1 text-[10px] font-bold uppercase text-black">Call</span>
            <span className="rounded-full border border-white/30 px-3 py-1 text-[10px] font-bold uppercase">Text</span>
          </div>
        )}
        {d.show_buyer_message && form.message.trim() && (
          <div className="mt-3 whitespace-pre-line rounded border border-white/15 p-2 text-left text-[11px]" data-testid="admin-ty-preview-message">{form.message}</div>
        )}
        {d.show_timeline && (
          <ol className="mt-3 space-y-1 text-left text-[11px]" data-testid="admin-ty-preview-timeline">
            {steps.map((s, i) => <li key={i}><b className="text-white">{i + 1}. {s.title}</b> {s.body}</li>)}
          </ol>
        )}
      </div>
      <div className="mt-2 text-[10.5px] text-zinc-600">
        {page.kind === "funnel"
          ? "Firm details appear when a buyer is matched; the headline and message apply unless the buyer has its own. Unmatched leads see the Conecme thank-you page."
          : "Shown after any shared funnel sends a lead to this buyer."}
      </div>
    </div>
  );
};
